import Utils from '../Common/Utils.js';


const formatAndMergePainData = (oldPainData, newPainData) => {

    let local_data = [];
    let isANewDateValue = "";

    if (oldPainData !== undefined){
        Utils.mergeBasicOldData(oldPainData, local_data)
    }

    if (newPainData !== undefined){
        if(newPainData.length !== 0){
            for (var i = newPainData.length-1; i >= 0; i--){        // Find new values and add it
                isANewDateValue = local_data.find(xDate => { return xDate.x === new Date(newPainData[i].eventDate).getTime() })
                if(isANewDateValue === undefined){
                    local_data.push({x: new Date(newPainData[i].eventDate).getTime(), y: Number(newPainData[i].value)})
                }
            }
        }
    }
    return local_data;
}




//Const to import functions in other files
const PainDataManager = {
  formatAndMergePainData
};

export default PainDataManager;